/*
 * The size guide (snippet cubica-size-guide): remembers cm or inches, and in the product sheet marks the size
 * already chosen. The unit switch itself is CSS, on the checked radio.
 */
(() => {
  if (window.cubicaSizeGuide) return;
  window.cubicaSizeGuide = true;
  const KEY = 'cubica:size-unit';
  const read = () => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  };
  const apply = () => {
    const unit = read();
    if (unit) document.querySelectorAll(`[data-size-guide] input[value="${unit}"]`).forEach((input) => (input.checked = true));
  };
  apply();
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('[data-size-guide] input[type="radio"]')) return;
    try {
      localStorage.setItem(KEY, event.target.value);
    } catch {}
  });
  document.addEventListener('cubica:dialog:open', (event) => {
    const guide = document.getElementById(event.detail?.id)?.querySelector('[data-size-guide][data-size-position]');
    if (!guide) return;
    const chosen = document.querySelector(`[data-option="${guide.dataset.sizePosition}"] [aria-pressed="true"]`)?.dataset.value;
    guide.querySelectorAll('[data-size]').forEach((cell) => cell.toggleAttribute('data-current', cell.dataset.size === chosen));
  });
})();
